import { useMemo } from "react";
import { isAfter } from "date-fns";

import { UserPosition } from "graphql/types";
import { useActiveCompany } from "components/companies/ActiveCompanyProvider";
import { ApiPartnerName } from "components/companies/common";
import { isPosthogFeatureFlagEnabled } from "lib/analytics/featureFlags";
import { FeatureFlag } from "lib/analytics/featureFlags";
import { useSelf } from "components/users/useSelf";

export enum LaunchpadType {
  Brex = "Brex",
  Bookkeepers = "Bookkeepers",
  Default = "Default",
}

const BOOKKEEPERS_START_DATE = new Date("2025-05-28");

export const useLaunchpadConfig = () => {
  const { membership, company } = useActiveCompany<true>();
  const { self } = useSelf();

  const createdAt = company?.createdAt;
  const isCreatedAfterStartDate = createdAt && isAfter(createdAt, BOOKKEEPERS_START_DATE);
  const isOnboardingLaunchpadVariantsEnabled = isPosthogFeatureFlagEnabled(
    FeatureFlag.OnboardingLaunchpadVariants
  );
  const showBookkeepersTaskSet =
    !self?.invitedBy &&
    membership?.position === UserPosition.OutsourcedAccountantOrCfo &&
    isOnboardingLaunchpadVariantsEnabled &&
    isCreatedAfterStartDate;

  const showBrex =
    isPosthogFeatureFlagEnabled(FeatureFlag.OnboardingLaunchpadCheckBrex) &&
    company?.createdByApiPartnerName === ApiPartnerName.Brex;

  // Temporary for testing
  const forceBrex = isPosthogFeatureFlagEnabled(FeatureFlag.OnboardingLaunchpadForceBrex);

  const type = useMemo(() => {
    if (showBrex || forceBrex) {
      return LaunchpadType.Brex;
    }

    if (showBookkeepersTaskSet) {
      return LaunchpadType.Bookkeepers;
    }

    return LaunchpadType.Default;
  }, [showBrex, forceBrex, showBookkeepersTaskSet]);

  return {
    type,
  };
};
